import { render, staticRenderFns } from "./enumerationType.vue?vue&type=template&id=dd72bba6&scoped=true&"
import script from "./enumerationType.vue?vue&type=script&lang=js&"
export * from "./enumerationType.vue?vue&type=script&lang=js&"
import style0 from "./enumerationType.vue?vue&type=style&index=0&id=dd72bba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd72bba6",
  null
  
)

export default component.exports